import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatButtonToggle } from '@angular/material/button-toggle';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { Point } from '../../models/interfaces/point';
import { MapComponent } from '../map.component';

@Component({
  selector: 'bt-map-zoom-controls',
  templateUrl: './map-zoom-controls.component.html',
  styleUrls: ['./map-zoom-controls.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonToggle, MatCard, MatDivider, MatIcon, MatIconButton]
})
export class MapZoomControlsComponent implements OnInit {
  @Input() map: MapComponent;
  @ViewChild('autoControl', { static: true }) autoControl: MatButtonToggle;

  private zoomLevels: number[] = [
    0.05, 0.1, 0.15, 0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5,
    1.75, 2, 2.5, 3, 4, 5, 10
  ];

  ngOnInit() {
    if (this.map) {
      this.map
        .getCanvasContainer()
        .addEventListener('wheel', (event: WheelEvent) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (Math.abs(event.deltaY) > 15) {
            this.zoom(event.deltaY < 0, { x: event.offsetX, y: event.offsetY });
          }
        });
    }
  }

  toggleAutoZoom() {
    const zoom = this.autoControl.checked ? 'auto' : 1;
    this.map.setZoom(zoom);
  }

  zoom(zoomIn: boolean, point: Point = null) {
    const currentZoom = this.map.getCanvas().getZoom();
    const levels = zoomIn ? this.zoomLevels : this.zoomLevels.slice().reverse();

    for (const level of levels) {
      if (zoomIn ? level > currentZoom : level < currentZoom) {
        this.map.setZoom(level, point);
        return;
      }
    }
  }
}
